import { RouteObject } from "react-router-dom";
import { SelfServeGuard } from "./SelfServeRoutes";
import AuthorizedRoute from "containers/Page/Permissions/AuthorizedRoute";
import Survey from "./steps/questions/Survey";
import ProductCatalogUpload from "./steps/catalog/CatalogUpload";
import Verification from "./steps/verification/Verification";
import { ENROLL_PATH, ONBOARDING_STEPS } from "types/onboarding";

export const selfServeRouteObjects: RouteObject[] = [
  {
    path: `/${ENROLL_PATH}/*`,
    element: (
      <AuthorizedRoute>
        <SelfServeGuard />
      </AuthorizedRoute>
    ),
    children: [
      { path: `${ONBOARDING_STEPS.survey}`, element: <Survey /> },
      {
        path: `${ONBOARDING_STEPS.catalog}`,
        element: <ProductCatalogUpload />,
      },
      { path: `${ONBOARDING_STEPS.verifyEmail}`, element: <Verification /> },
    ],
  },
];
